import angular from 'angular'
import controller from './controller.js'
import template from './template.html'
import './style.css'

import mainMenu from '../../shared/menu/menu.html'
const menu = '<h2 class="dash-header" hide-xs><span>Direct Deposit</span></h2><span flex></span>'

export default angular.module('dwolla', ['ui.router'])
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.directDeposit', {
      url: '/direct-deposit',
      views: {
        content: {
          controller: controller,
          controllerAs: 'ctrl',
          template: template
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
